<div style="display: flex">
    <p-dialog header="Are you sure?" [(visible)]="areYouSureDialog" [maximizable]="false">
        <h4>
            Are you ABSOLUTELY sure you want to continue submitting job 47 (Recycle Data)?
        </h4>
        <ng-template #footer>
            <button type="button" pButton class="p-button-secondary" (click)="queueJob47()" label="Continue"></button>
            <button type="button" pButton class="p-button-secondary"
                (click)="this.selectedJob = null; this.areYouSureDialog = false;" label="Cancel"></button>
        </ng-template>
    </p-dialog>
</div>
<p-dialog
    header="Add Purchase"
    [(visible)]="showAddPurchaseDialog"
    [modal]="true"
    [draggable]="false"
    [style]="{ width: 'min(90vw, 32rem)' }"
    (onHide)="cancelAddPurchase()">
    <div class="flex flex-column gap-3">
        <div class="p-1 flex justify-content-center">
            <p-floatLabel variant="on" class="w-full">
                <input
                    type="text"
                    class="w-full"
                    id="emailAddr"
                    pInputText
                    [(ngModel)]="newPurchase.EmailAddr" />
                <label for="emailAddr">Email Address</label>
            </p-floatLabel>
        </div>
        <div class="p-1 flex justify-content-center">
            <p-floatLabel variant="on" class="w-full">
                <p-calendar
                    inputId="newPurchaseDate"
                    class="w-full"
                    [monthNavigator]="true"
                    [yearNavigator]="true"
                    yearRange="2000:2030"
                    [(ngModel)]="newPurchase.PurchaseDate"
                    appendTo="body"
                    [showIcon]="true">
                </p-calendar>
                <label for="newPurchaseDate">Purchase Date</label>
            </p-floatLabel>
        </div>
        <div class="p-1 flex justify-content-center">
            <p-floatLabel variant="on" class="w-full">
                <input
                    type="text"
                    class="w-full"
                    id="newProductName"
                    pInputText
                    [(ngModel)]="newPurchase.ProductName" />
                <label for="newProductName">Product Name</label>
            </p-floatLabel>
        </div>
        <div class="p-1 flex justify-content-center">
            <p-floatLabel variant="on" class="w-full">
                <input
                    type="number"
                    class="w-full"
                    id="newProductId"
                    pInputText
                    [(ngModel)]="newPurchase.ProductID" />
                <label for="newProductId">Product ID</label>
            </p-floatLabel>
        </div>
        <div class="p-1 flex justify-content-center">
            <p-floatLabel variant="on" class="w-full">
                <p-select
                    inputId="newSubscriptionType"
                    styleClass="w-full"
                    appendTo="body"
                    [options]="subscriptionTypeOptions"
                    [(ngModel)]="newPurchase.Subscription"
                    optionLabel="label"
                    optionValue="value"
                    placeholder=" ">
                </p-select>
                <label for="newSubscriptionType">Type</label>
            </p-floatLabel>
        </div>
        <div class="p-1 flex justify-content-center">
            <p-floatLabel variant="on" class="w-full">
                <input
                    type="text"
                    class="w-full"
                    id="newSubscriptionId"
                    pInputText
                    [(ngModel)]="newPurchase.SubscriptionID" />
                <label for="newSubscriptionId">Subscription ID</label>
            </p-floatLabel>
        </div>
        <div class="p-1 flex justify-content-center">
            <p-floatLabel variant="on" class="w-full">
                <p-calendar
                    inputId="newPaidThruDate"
                    class="w-full"
                    [monthNavigator]="true"
                    [yearNavigator]="true"
                    yearRange="2000:2030"
                    [(ngModel)]="newPurchase.PaidThruDate"
                    appendTo="body"
                    [showIcon]="true">
                </p-calendar>
                <label for="newPaidThruDate">Paid Through</label>
            </p-floatLabel>
        </div>
        <div class="p-1 flex justify-content-center">
            <p-floatLabel variant="on" class="w-full">
                <p-calendar
                    inputId="newCancelDate"
                    class="w-full"
                    [monthNavigator]="true"
                    [yearNavigator]="true"
                    yearRange="2000:2030"
                    [(ngModel)]="newPurchase.CancelDate"
                    appendTo="body"
                    [showIcon]="true">
                </p-calendar>
                <label for="newCancelDate">Cancel Date</label>
            </p-floatLabel>
        </div>
        <p-message
            *ngIf="addPurchaseError"
            severity="error"
            [text]="addPurchaseError"
            styleClass="w-full">
        </p-message>
    </div>
    <ng-template #footer>
        <button
            type="button"
            pButton
            class="p-button-secondary"
            label="Cancel"
            (click)="cancelAddPurchase()">
        </button>
        <button
            type="button"
            pButton
            class="p-button-secondary"
            icon="pi pi-plus"
            label="Add"
            (click)="addPurchase()">
        </button>
    </ng-template>
</p-dialog>
<div class="flex justify-content-end p-3 pb-0">
    <button
        pButton
        type="button"
        icon="pi pi-list"
        label="Authorize.Net Subscriptions"
        severity="secondary"
        (click)="showAuthorizeNetSubscriptionsDialog = true"></button>
</div>
<ef-authorizenet-subscriptions-dialog
    [(visible)]="showAuthorizeNetSubscriptionsDialog"></ef-authorizenet-subscriptions-dialog>
<div class="card">
    <p-tabs value="0">
        <p-tablist>
            <p-tab value="0">Customer Information</p-tab>
            <p-tab value="1">Customer Database</p-tab>
            <p-tab value="2">Queue Jobs</p-tab>
            <p-tab value="3" [disabled]="true">Restart/Reboot Agent</p-tab>
            <p-tab value="4">Targeted Logging</p-tab>
        </p-tablist>

        <p-tabpanels>
            <p-tabpanel value="0">
            <!--MESSAGE-->
            <div class="col col-12" *ngIf="this.items && this.items[0].eFCModifiedBy != null">
                <div class="surface-card border-round shadow-2 p-2 flex justify-content-center">
                    <p-message style="width: 100%;" severity="info" [text]="this.modified"></p-message>
                </div>
            </div>
            <!--CUSTOMER DDL-->
            <div class="col col-12">
                <div class="p-3 w-5">
                    <p-floatLabel variant="on" class="w-full">
                        <p-dropdown placeholder="eFAACT Customer" appendTo="body" [filter]="true"
                            autoDisplayFirst="false" [options]="allCustomersSelectItem" [(ngModel)]="selectedCustomer"
                            (onChange)="customerChanged($event)">
                        </p-dropdown>
                        <label for="admincount">eFAACT Customer</label>
                    </p-floatLabel>
                </div>
            </div>
            <div class="grid h-full">
                <!--COMPANY INFO-->
                <div class="col col-auto xl:col-6 lg:col-12 md:col-12 sm:col-12 xs:col-12">
                    <div class="surface-card border-round text-center shadow-2 p-1">
                        <div class="flex flex-row p-3">
                            <span class="text-xl text-left font-medium text-90">Company Info</span>
                            <button pButton type="button" [icon]="editCustomerBtnIcon" [label]="editCustomerBtnLabel"
                                class="p-button-secondary" (click)="editCustomerInfo()"></button>
                        </div>
                        <div class="p-3 mt-9 mb-6">
                            <div class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="customerid" pInputText [(ngModel)]="companyName"
                                        [disabled]="!this.editingCustomer">
                                    <label for="customerid">Company</label>
                                </p-floatLabel>
                            </div>
                            <div class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <p-dropdown placeholder="Host Provider" appendTo="body" [filter]="true"
                                        autoDisplayFirst="false" [options]="hostProvidersSelectItem"
                                        [(ngModel)]="hostProvider" [disabled]="!this.editingCustomer">
                                    </p-dropdown>
                                    <label for="customerid">Host Provider</label>
                                </p-floatLabel>
                            </div>
                            <div class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="address" pInputText [(ngModel)]="address"
                                        [disabled]="!this.editingCustomer">
                                    <label for="address">Address 1</label>
                                </p-floatLabel>
                            </div>
                            <div class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="address2" pInputText [(ngModel)]="address2"
                                        [disabled]="!this.editingCustomer">
                                    <label for="address2">Address 2</label>
                                </p-floatLabel>
                            </div>
                            <div class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="pin" pInputText [(ngModel)]="address3"
                                        [disabled]="!this.editingCustomer">
                                    <label for="address3">Address 3</label>
                                </p-floatLabel>
                            </div>
                            <div class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="productcode" pInputText [(ngModel)]="city"
                                        [disabled]="!this.editingCustomer">
                                    <label for="productcode">City</label>
                                </p-floatLabel>
                            </div>
                            <div class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <p-dropdown placeholder="State" appendTo="body" [filter]="true"
                                        autoDisplayFirst="false" [options]="statesSelectItem"
                                        [(ngModel)]="selectedState" [disabled]="!this.editingCustomer">
                                    </p-dropdown>
                                    <label for="admincount">State</label>
                                </p-floatLabel>
                            </div>
                            <div class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="admincount" pInputText [(ngModel)]="zip"
                                        [disabled]="!this.editingCustomer">
                                    <label for="admincount">Zip</label>
                                </p-floatLabel>
                            </div>
                            <div *ngIf="installLink != null" class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="link" pInputText [(ngModel)]="installLink"
                                        [disabled]="!this.editingCustomer">
                                    <label for="link">Desktop Install Link</label>
                                </p-floatLabel>
                            </div>
                            <div *ngIf="microsoftDriverLink != null" class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="mdlink" pInputText [(ngModel)]="microsoftDriverLink"
                                        [disabled]="!this.editingCustomer">
                                    <label for="mdlink">Microsoft Driver MSOLEDBSQL</label>
                                </p-floatLabel>
                            </div>
                            <div *ngIf="crystalReportsLink != null" class="p-4 mb-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="crlink" pInputText [(ngModel)]="crystalReportsLink"
                                        [disabled]="!this.editingCustomer">
                                    <label for="crlink">Crystal Reports</label>
                                </p-floatLabel>
                            </div>
                        </div>
                        <div class="flex justify-content-end mb-3 mr-3">
                            <button pButton type="button" icon="pi pi-check" label="Update" class="p-button-secondary"
                                (click)="updateCustomerInfo()" [disabled]="!this.editingCustomer"></button>
                        </div>
                    </div>
                </div>
                <!--LICENSE INFO-->
                <div class="col col-auto xl:col-6 lg:col-12 md:col-12 sm:col-12 xs:col-12">
                    <div class="surface-card border-round text-center shadow-2 p-1" style="height: 100%">
                        <div class="flex flex-row p-3">
                            <span class="text-xl text-left font-medium text-90">License Info</span>
                            <button pButton type="button" [icon]="editLicenseBtnIcon" [label]="editLicenseBtnLabel" class="p-button-secondary" (click)="editLicenseInfo()"></button>
                        </div>
                        <div class="p-3">
                            <div class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="customerid" pInputText [(ngModel)]="customerID"
                                        [disabled]="!editingLicense">
                                    <label for="customerid">Customer ID</label>
                                </p-floatLabel>
                            </div>
                            <div class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="pin" pInputText [(ngModel)]="customerPIN"
                                        [disabled]="!editingLicense">
                                    <label for="pin">Customer PIN</label>
                                </p-floatLabel>
                            </div>
                            <div class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="productcode" pInputText [(ngModel)]="productCode"
                                        [disabled]="!editingLicense">
                                    <label for="productcode">Product Code</label>
                                </p-floatLabel>
                            </div>
                            <div class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="number" class="w-full" id="adminCount" pInputText [(ngModel)]="adminCount"
                                        [disabled]="!editingLicense" min="1">
                                    <label for="adminCount">Admin Count</label>
                                </p-floatLabel>
                            </div>
                            <div class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="customerProfileId" pInputText
                                        [(ngModel)]="customerProfileID" [disabled]="!editingLicense">
                                    <label for="customerProfileId">Customer Profile ID</label>
                                </p-floatLabel>
                            </div>
                            <div class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="dbname" pInputText [(ngModel)]="dbname"
                                        [disabled]="!this.editingCustomer">
                                    <label for="dbname">Database Name</label>
                                </p-floatLabel>
                            </div>
                            <div class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="serverid" pInputText [(ngModel)]="serverID"
                                        [disabled]="!this.editingCustomer">
                                    <label for="serverid">Server ID</label>
                                </p-floatLabel>
                            </div>
                            <div class="p-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="servername" pInputText [(ngModel)]="serverName"
                                        [disabled]="!this.editingCustomer">
                                    <label for="servername">Server Name</label>
                                </p-floatLabel>
                            </div>
                            <div class="p-4 mb-4 flex justify-content-center">
                                <p-floatLabel variant="on" class="w-full">
                                    <input type="text" class="w-full" id="agentid" pInputText [(ngModel)]="agentID"
                                        [disabled]="!this.editingCustomer">
                                    <label for="agentid">Agent ID</label>
                                </p-floatLabel>
                            </div>
                        </div>
                        <div class="flex justify-content-end mb-3 mr-3">
                            <button pButton type="button" icon="pi pi-check" label="Update" class="p-button-secondary"
                                (click)="updateLicenseInfo()" [disabled]="!editingLicense"></button>
                        </div>
                    </div>
                </div>
                <!--PURCHASES-->
                <div class="col col-auto xl:col-6 lg:col-12 md:col-12 sm:col-12 xs:col-12">
                    <div class="surface-card border-round text-center shadow-2 p-1" style="height: 100%">
                        <div class="flex flex-row align-items-center justify-content-between p-3">
                            <span class="text-xl text-left font-medium text-90">Purchase Detail</span>
                            <button
                                pButton
                                type="button"
                                label="Add Purchase"
                                class="p-button-secondary"
                                [disabled]="!items || items.length === 0"
                                (click)="openAddPurchaseDialog()">
                            </button>
                        </div>
                        <div *ngIf="items && items.length > 0" class="p-3">
                            <p-table stripedRows #purchases class="border-round shadow-2" [scrollable]="true" scrollDirection="both"
                                scrollHeight="25vh" [value]="items[0].Purchases"
                                tableStyleClass="border-round table p-datatable-full" dataKey="ProductID">
                                <ng-template pTemplate="header" let-item>
                                    <tr>
                                        <th class="tabulator-colgroup-header p-header-cell tiny-cell">
                                            Purchase Date
                                        </th>
                                        <th class="tabulator-colgroup-header p-header-cell large-cell">
                                            Product Name
                                        </th>
                                        <th class="tabulator-colgroup-header p-header-cell large-cell">
                                            Product ID
                                        </th>
                                        <th class="tabulator-colgroup-header p-header-cell large-cell">
                                            Type
                                        </th>
                                        <th class="tabulator-colgroup-header p-header-cell large-cell">
                                            Subscription ID
                                        </th>
                                        <th class="tabulator-colgroup-header p-header-cell tiny-cell">
                                            Paid Through
                                        </th>
                                        <th class="tabulator-colgroup-header p-header-cell tiny-cell">
                                            Cancel Date
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item let-ri="rowIndex">
                                    <tr class="p-datatable-row">
                                        <td pEditableColumn class="p-datatable-cell tiny-cell">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <p-calendar [monthNavigator]="true" [yearNavigator]="true"
                                                        yearRange="2000:2030" [(ngModel)]="item.PurchaseDate"
                                                        appendTo="body"
                                                        (onSelect)="purchaseDateChanged(item)"></p-calendar>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ item.PurchaseDate | date: 'MM/dd/YYYY'}}
                                                </ng-template>
                                            </p-cellEditor>                                           
                                        </td>
                                        <td pEditableColumn class="p-datatable-cell large-cell">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <input type="text" class="w-full" id="productname" pInputText [(ngModel)]="item.ProductName" (change)="productNameChanged(item)" />
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ item.ProductName }}
                                                </ng-template>
                                            </p-cellEditor>                                           
                                        </td>                                       
                                        <td pEditableColumn class="p-datatable-cell tiny-cell">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <input type="text" class="w-full" id="productid" pInputText [(ngModel)]="item.ProductID" (change)="productIDChanged(item)" />
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ item.ProductID }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td pEditableColumn class="p-datatable-cell tiny-cell">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <input type="text" class="w-full" id="subscription" pInputText [(ngModel)]="item.Subscription" (change)="subscriptionTypeChanged(item)" />
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ item.Subscription }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td pEditableColumn class="p-datatable-cell tiny-cell">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <input type="text" class="w-full" id="subscriptionid" pInputText [(ngModel)]="item.SubscriptionID" (change)="subscriptionIDChanged(item)" />
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ item.SubscriptionID }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td pEditableColumn class="p-datatable-cell tiny-cell">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <p-calendar [monthNavigator]="true" [yearNavigator]="true"
                                                        yearRange="2000:2030" [(ngModel)]="item.PaidThruDate"
                                                        appendTo="body"
                                                        (onSelect)="paidThruDateChanged(item)"></p-calendar>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ item.MaintPaidThruDate | date: 'MM/dd/YYYY'}}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td class="p-datatable-cell tiny-cell">
                                            {{ item.CancelDate | date: 'MM/dd/YYYY' }}
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
                <!--AUTHORIZED ENTITY-->
                <div class="col col-auto xl:col-6 lg:col-12 md:col-12 sm:col-12 xs:col-12">
                    <div class="surface-card border-round text-center shadow-2 p-1" style="height: 100%">
                        <div class="flex flex-row p-3">
                            <span class="text-xl text-left font-medium text-90">Authorized Entity</span>
                            <button pButton type="button" [icon]="editAuthEntityBtnIcon"
                                [label]="editAuthEntityBtnLabel" class="p-button-secondary"
                                (click)="editAuthEntity()"></button>
                        </div>
                        <div class="p-3">
                            <div class="p-4">
                                <span>{{advisorMessage}}</span>
                            </div>
                            <div class="p-4 flex justify-content-center mb-4">
                                 <p-select styleClass="w-full" placeholder="Authorized Entity" appendTo="body" autoDisplayFirst="false"
                                    [options]="advisorsSelectItem" [(ngModel)]="selectedAdvisor"
                                    [disabled]="!editingAuthEntity">
                                </p-select>
                            </div>
                            <div class="flex justify-content-end mb-3 mr-3">
                                <button pButton type="button" icon="pi pi-check" label="Update"
                                    class="p-button-secondary" (click)="updateAdvisor()"
                                    [disabled]="!editingAuthEntity"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--MESSAGE-->
            <div class="col col-12" *ngIf="this.items && this.items[0].eFCModifiedBy != null">
                <div class="surface-card border-round shadow-2 p-2 flex justify-content-center">
                    <p-message style="width: 100%;" severity="info" [text]="this.modified"></p-message>
                </div>
            </div>
            </p-tabpanel>
            <p-tabpanel value="1">
            <!--MESSAGE-->
            <div class="col col-12" *ngIf="this.items && this.items[0].eFCModifiedBy != null">
                <div class="surface-card border-round shadow-2 p-2 flex justify-content-center">
                    <p-message style="width: 100%;" severity="info" [text]="this.modified"></p-message>
                </div>
            </div>
            <!--CUSTOMER DDL-->
            <div class="col col-12">
                <div class="p-3 w-5">
                    <p-floatLabel variant="on" class="w-full">
                         <p-select styleClass="w-full" placeholder="eFAACT Customer" appendTo="body" [filter]="true"
                            autoDisplayFirst="false" [options]="allCustomersSelectItem" [(ngModel)]="selectedCustomer"
                            (onChange)="customerChanged($event)">
                        </p-select>
                        <label for="admincount">eFAACT Customer</label>
                    </p-floatLabel>
                </div>
            </div>
            <div class="grid h-full">
                <!--CUSTOMER DB UPDATES-->
                <div class="col col-auto xl:col-6 lg:col-12 md:col-12 sm:col-12 xs:col-12">
                    <div class="surface-card border-round text-center shadow-2 p-1">
                        <div class="flex flex-row p-3">
                            <span class="text-xl text-left font-medium text-90">Customer Database</span>
                            <button pButton type="button" [icon]="editCustomerDBBtnIcon"
                                [label]="editCustomerDBBtnLabel" class="p-button-secondary"
                                (click)="editCustomerDB()"></button>
                        </div>

                        <div class="p-4 flex items-center">
                            <p-checkbox binary="true"
                                [(ngModel)]="isQBO" (onChange)="isQBOChanged($event)"
                                [disabled]="!this.editingCustomerDB"></p-checkbox>
                                <label class="ml-2">Turn ON/OFF QuickBooks Online for Customer</label>
                        </div>
                        <div class="p-4 flex items-center">
                            <p-checkbox binary="true" [(ngModel)]="isGCP"
                                (onChange)="isGCPChanged($event)" [disabled]="!this.editingCustomerDB"></p-checkbox>
                                <label class="ml-2">Turn ON/OFF GCP for Customer</label>
                        </div>
                        <div class="p-4 mb-6 flex justify-content-center">
                            <p-floatLabel variant="on" class="w-full">
                                <input type="text" class="w-full" id="taxid" pInputText [(ngModel)]="taxID"
                                    [disabled]="!this.editingCustomerDB">
                                <label for="taxid">Tax ID</label>
                            </p-floatLabel>
                        </div>

                        <div class="absolute right-0 bottom-0 p-4">
                            <button pButton type="button" icon="pi pi-check" label="Update" class="p-button-secondary"
                                (click)="updateCustomerDB()" [disabled]="!this.editingCustomerDB"></button>
                        </div>
                    </div>
                </div>
            </div>
            </p-tabpanel>
            <p-tabpanel value="2">
            <!--QUEUE JOBS-->
            <div class="col col-auto xl:col-6 lg:col-12 md:col-12 sm:col-12 xs:col-12">
                <div class="surface-card border-round shadow-2 p-2 flex justify-content-center">
                    <!-- <p-progressBar [value]="percentComplete"></p-progressBar> -->
                    <p-messages></p-messages>
                    <!-- <p-message style="width: 100%;" severity="info" [text]="this.queueResp"></p-message> -->
                </div>
            </div>

            <div class="col col-auto xl:col-6 lg:col-12 md:col-12 sm:col-12 xs:col-12">
                <div class="surface-card border-round shadow-2 p-1" style="height: 100%">
                    <div class="flex flex-row p-3">
                        <span class="text-xl text-left font-medium text-90">Queue Job</span>
                        <button pButton pRipple type="button" severity="info" text style="min-width: 6rem !important;" label="Clear"
                            (click)="clearQueueJobsForm()"></button>
                    </div>
                    <div class="p-3">
                        <div class="flex items-center">
                            <p-checkbox binary="true" [(ngModel)]="includeRecycleData"
                            (onChange)="addRecycleDataToJobList($event)"></p-checkbox>
                            <label class="ml-2">Include Recycle Data job</label>
                        </div>

                        <div class="p-4 flex justify-content-center">
                            <p-floatLabel variant="on" class="w-full">
                                 <p-select styleClass="w-full" appendTo="body" [filter]="true" autoDisplayFirst="false"
                                    [options]="jobsSelectItem" [(ngModel)]="selectedJob">
                                </p-select>
                                <label for="admincount">Job</label>
                            </p-floatLabel>
                        </div>
                        <div *ngIf="this.selectedJob != null && this.selectedJob == 46"
                            class="p-4 mb-4 flex justify-content-center">
                            <p-floatLabel variant="on" class="w-full">
                                <input type="text" class="w-full" id="sp" pInputText [(ngModel)]="storedProcedure">
                                <label for="sp">Stored Procedure</label>
                            </p-floatLabel>
                        </div>

                        <div class="button-bar"></div>

                        <div class="flex items-center">
                            <p-checkbox *ngIf="selectedJob && selectedJob == 5" binary="true"
                            [(ngModel)]="queueJobTestCustomers" (onChange)="queueForTestChanged($event)"></p-checkbox>
                            <label *ngIf="selectedJob && selectedJob == 5" class="ml-2">Test Customers Only</label>
                        </div>

                        <div class="button-bar"></div>

                        <div class="flex items-center">
                            <p-checkbox *ngIf="selectedJob && selectedJob == 5" binary="true" label="All eFAACT Customers"
                            [(ngModel)]="queueJobAllCustomers" (onChange)="queueForAllChanged($event)"></p-checkbox>
                            <label *ngIf="selectedJob && selectedJob == 5" class="ml-2">All eFAACT Customers</label>
                        </div>

                        <div class="flex p-4 justify-content-center">
                            <p-floatLabel variant="on" class="w-full">
                                 <p-select styleClass="w-full" appendTo="body" [filter]="true"
                                    autoDisplayFirst="false" [options]="customersSelectItem"
                                    [(ngModel)]="selectedCustomer" [disabled]="queueJobAllCustomers == true">
                                </p-select>
                                <label for="admincount">eFAACT Customer</label>
                            </p-floatLabel>
                        </div>
                        <button pButton type="button" icon="pi pi-upload" label="Queue" class="p-button-secondary"
                            (click)="queueJob()"></button>
                    </div>
                </div>
            </div>
            </p-tabpanel>
            <p-tabpanel value="3">
                eFAACT Agent Restart or Reboot
            </p-tabpanel>
            <p-tabpanel value="4">
            <div class="col col-12">
                <div class="surface-card border-round shadow-2 p-2 flex justify-content-center">
                    <p-messages></p-messages>
                </div>
            </div>
            <div class="grid h-full">
                <div class="col col-12">
                    <div class="surface-card border-round shadow-2 p-3">
                        <div class="flex flex-row p-3">
                            <span class="text-xl text-left font-medium text-90">Trace Logging Overrides</span>
                            <button pButton pRipple type="button" severity="info" text style="min-width: 6rem !important;"
                                label="Clear" (click)="clearTraceLoggingForm()"></button>
                        </div>
                        <p-table *ngIf="traceLoggingOverrides" [value]="traceLoggingOverrides" stripedRows
                            scrollHeight="30vh" [scrollable]="true" dataKey="TraceLoggingOverrideId">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>ID</th>
                                    <th>Customer</th>
                                    <th>Login</th>
                                    <th>Level</th>
                                    <th>Targets</th>
                                    <th>Enabled</th>
                                    <th>Expires (UTC)</th>
                                    <th>Notes</th>
                                    <th></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-row>
                                <tr>
                                    <td>{{ row.TraceLoggingOverrideId }}</td>
                                    <td>{{ row.CustomerId }}</td>
                                    <td>{{ row.LoginName }}</td>
                                    <td>{{ row.MinLogLevel }}</td>
                                    <td>{{ row.LogTargets }}</td>
                                    <td>{{ row.Enabled ? 'Yes' : 'No' }}</td>
                                    <td>{{ row.ExpiresUtc | date: 'MM/dd/yyyy HH:mm' : 'UTC' }}</td>
                                    <td>{{ row.Notes }}</td>
                                    <td>
                                        <button pButton type="button" icon="pi pi-pencil" class="p-button-text"
                                            (click)="editTraceLoggingOverride(row)"></button>
                                        <button pButton type="button" icon="pi pi-ban" class="p-button-text"
                                            [disabled]="!row.Enabled" (click)="disableTraceLoggingOverride(row)"></button>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
                <div class="col col-auto xl:col-6 lg:col-12 md:col-12 sm:col-12 xs:col-12">
                    <div class="surface-card border-round shadow-2 p-3">
                        <div class="flex flex-row p-3">
                            <span class="text-xl text-left font-medium text-90">
                                {{ editingTraceLoggingOverrideId ? 'Edit Override' : 'Add Override' }}
                            </span>
                        </div>
                        <div class="p-4 flex justify-content-center">
                            <p-floatLabel variant="on" class="w-full">
                                <p-select styleClass="w-full" appendTo="body"
                                    [filter]="true" autoDisplayFirst="false" [options]="allCustomersSelectItem"
                                    [(ngModel)]="traceLoggingCustomerId" [showClear]="true">
                                </p-select>
                                <label>Customer (optional)</label>
                            </p-floatLabel>
                        </div>
                        <div class="p-4 flex justify-content-center">
                            <p-floatLabel variant="on" class="w-full">
                                <input type="text" class="w-full" pInputText [(ngModel)]="traceLoggingLoginName">
                                <label>Login Name (optional)</label>
                            </p-floatLabel>
                        </div>
                        <div class="p-4 flex justify-content-center">
                            <p-floatLabel variant="on" class="w-full">
                                <p-select styleClass="w-full" appendTo="body" [options]="minLogLevelSelectItem"
                                    [(ngModel)]="traceLoggingMinLogLevel">
                                </p-select>
                                <label>Minimum Log Level</label>
                            </p-floatLabel>
                        </div>
                        <div class="p-4 flex justify-content-center">
                            <p-floatLabel variant="on" class="w-full">
                                <p-multiSelect styleClass="w-full" appendTo="body" [options]="logTargetSelectItem"
                                    [(ngModel)]="traceLoggingLogTargets">
                                </p-multiSelect>
                                <label>Log Targets (optional)</label>
                            </p-floatLabel>
                        </div>
                        <div class="p-4 flex items-center">
                            <p-checkbox binary="true" [(ngModel)]="traceLoggingEnabled"></p-checkbox>
                            <label class="ml-2">Enabled</label>
                        </div>
                        <div class="p-4 flex justify-content-center">
                            <p-floatLabel variant="on" class="w-full">
                                <p-calendar [(ngModel)]="traceLoggingExpiresUtc" appendTo="body" [showTime]="true"
                                    hourFormat="24" [showClear]="true"></p-calendar>
                                <label>Expires (UTC)</label>
                            </p-floatLabel>
                        </div>
                        <div class="p-4 flex justify-content-center">
                            <p-floatLabel variant="on" class="w-full">
                                <textarea class="w-full" pTextarea rows="3" [(ngModel)]="traceLoggingNotes"></textarea>
                                <label>Notes</label>
                            </p-floatLabel>
                        </div>
                        <div class="flex justify-content-end mb-3 mr-3">
                            <button pButton type="button" icon="pi pi-check" label="Save" class="p-button-secondary"
                                (click)="saveTraceLoggingOverride()"></button>
                        </div>
                    </div>
                </div>
            </div>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
</div>
